import React, { useEffect, useState, } from 'react'
import Container from '../../../ui/comp/Container'
import { Axios } from '../../../utils/Axios'
import HeaderOneCon from './HeaderOneCon'
import Button from '../../../ui/comp/Button'
import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'

function HeaderOne() {

    const [datas, setDatas] = useState([])

    useEffect(() => {

        const fetchData = async () => {
            const res = await Axios.get('/store/header');
            const data = await res.data
            setDatas(Array(1).fill({ title: "", link_name: "", link_url: "" }).map((val, i) => {
                return data[i] || val
            }))
        }

        fetchData()
    },
        []
    )

    // Handle input change
    const handleInputChange = (index, field, value) => {
        const updatedArray = datas.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setDatas(updatedArray);
    };

    // send or update data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/store/header', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            toast.success("Header updated")
        }
    })

    const sendData = () => {
        mutate({ data: JSON.stringify(datas) })
    }

    return (
        <div className='w-full relative'>
            <Container title={"Small Header"}>

                {/* Datas */}
                <div className="w-full mt-5">
                    <HeaderOneCon
                        index={0}
                        inputChange={handleInputChange}
                        data={datas[0] || { title: "", link_name: "", link_url: "" }}
                    />
                </div>

                <div className="mt-6">
                    <Button onClick={sendData} loading={isPending}>Update</Button>
                </div>
            </Container>
        </div>
    )
}

export default HeaderOne